"use client"

import { useEffect, useState, useRef } from "react"
import { useLocation } from "react-router-dom"

export enum VARIANT {
  UNIQUE = "UNIQUE",
  DOUBLE = "DOUBLE",
}

export function Load() {
  const location = useLocation();
  const [messageIndex, setMessageIndex] = useState(0);
  const loadingMessages = [
    "Preparando o ambiente...",
    "Carregando dados essenciais...",
    "Otimizando a experiência...",
    "Quase lá, só mais um instante...",
  ];
  const messagesLengthRef = useRef(loadingMessages.length);

  useEffect(() => {
    document.body.classList.add("no-scroll");
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % messagesLengthRef.current);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const renderSkeletonContent = () => {
    const backgroundClass = location.pathname.startsWith("/conciliacao/lojas/conciliacao-de-caixa-de-loja/")
      ? "bg-white h-screen min-h-screen max-h-screen "
      : "bg-background min-h-screen";

    return (
      <div className={`absolute z-50 w-full inset-0 flex flex-col items-center justify-center ${backgroundClass}`}>
        <svg
          className="animate-spin h-12 w-12 text-primary"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <p className="mt-4 text-lg font-medium text-[#2E0D1E] text-center px-4">
          {loadingMessages[messageIndex]}
        </p>
      </div>
    );
  };

  return <>{renderSkeletonContent()}</>;
}
